import React from 'react';
import {evaluateFunction, Values} from '@wix/devzai-utils-common';
import {
    ScrollView,
    useScrollViewMaxScrollLeftBinding,
    useScrollViewMaxScrollTopBinding,
    useScrollViewScrollLeftBinding,
    useScrollViewScrollTopBinding
} from "../scroll-view/scroll-view";

export const ScrollViewEdgeDisabledSide = {
    Top: 'top',
    Bottom: 'bottom',
    Left: 'left',
    Right: 'right'
} as const;

export type ScrollViewEdgeDisabledSide = Values<typeof ScrollViewEdgeDisabledSide>;

export const ScrollViewEdgeDisabled = React.memo(function ScrollViewEdgeDisabled (props: ScrollViewEdgeDisabled.Props) {
    const {
        side,
        children,
        className,
        scrollViewRef,
        isRtl = false,

        ...htmlAttributes
    } = props;

    const multipleRtl = isRtl ? -1 : 1;

    const scrollTop = useScrollViewScrollTopBinding(scrollViewRef) ?? 0;
    const maxScrollTop = useScrollViewMaxScrollTopBinding(scrollViewRef) ?? Infinity;
    const scrollLeft = useScrollViewScrollLeftBinding(scrollViewRef) ?? 0;
    const maxScrollLeft = (useScrollViewMaxScrollLeftBinding(scrollViewRef) ?? Infinity) * multipleRtl;



    return (
        <div
            className={className}
             {...htmlAttributes}
        >
            {
                evaluateFunction(() => {
                    if(isRtl) {
                        if (side === ScrollViewEdgeDisabledSide.Left) {
                            if (scrollLeft >= 0) {
                                return children(true, scrollLeft <= maxScrollLeft);
                            }
                        } else if (side === ScrollViewEdgeDisabledSide.Right) {
                            if (scrollLeft <= maxScrollLeft) {
                                return children(true, scrollLeft >= 0);
                            }
                        }
                    }
                    else {
                        if (side === ScrollViewEdgeDisabledSide.Left) {
                            if (scrollLeft <= 0) {
                                return children(true, scrollLeft >= maxScrollLeft);
                            }
                        } else if (side === ScrollViewEdgeDisabledSide.Right) {
                            if (scrollLeft >= maxScrollLeft) {
                                return children(true, scrollLeft <= 0);
                            }
                        }
                    }

                    if (side === ScrollViewEdgeDisabledSide.Top) {
                        if (scrollTop <= 0) {
                            return children(true);
                        }
                    } else if (side === ScrollViewEdgeDisabledSide.Bottom) {
                        if (scrollTop >= maxScrollTop) {
                            return children(true);
                        }
                    }

                    return children(false);
                })
            }
        </div>
    );
});

export namespace ScrollViewEdgeDisabled {

    export interface Props extends React.HTMLAttributes<any> {
        side: ScrollViewEdgeDisabledSide;
        scrollViewRef: React.RefObject<ScrollView>;
        children: (isDisabled: boolean, hasNoScrolling?: boolean) => React.ReactElement;
        isRtl?: boolean;
    }
}
